import React, { Component } from 'react';
import * as customers from 'customers/actions/customers';
import { connect } from 'react-redux';
import { DetailContainer } from 'customers/DetailContainer';
import Loading from 'apa/components/Loading';
import autobind from 'autobind-decorator';

@connect(
    state => {
        return {
            customers: state.customers,
            auth: state.apa
        }
    },
    dispatch => {
        return {
            fetchCustomer: (customer_id, callback) => {
                dispatch(customers.fetchCustomer(customer_id, callback))
            }
        }
    }
)
export default class ZoneList extends Component {


    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            customer: null,
            zoneList: [],
            zoneListLoaded: false,
            newParameter: {
                zone_id: '',
                name: '',
                m2: '',
                kommentar: ''
            },
            parameterList: []
        };
    }

    @autobind
    getCustomer() {
        const id = this.props.match.params.id;
        this.props.fetchCustomer(id,
            customer => this.setState({
                isLoading: false,
                customer: customer,
                newParameter: {
                    ...this.state.newParameter,
                    customer: customer.id
                },
                parameterList: customer.parameters
            }
            )
        );
    }

    componentDidMount() {
        this.getCustomer()
        const headers = {
            'Authorization': `Token ${this.props.auth.token}`,
            'Content-Type': 'application/json'
        };
        fetch(
            '/api/zones/',
            { headers }
        ).then(
            res => res.json()
        ).then(
            zoneList => this.setState({
                zoneListLoaded: true,
                zoneList: zoneList
            })
        )

    }

    @autobind
    addNewParameter(event) {
        event.preventDefault()
        const headers = {
            'Authorization': `Token ${this.props.auth.token}`,
            'Content-Type': 'application/json'
        };
        const body = JSON.stringify(
            this.state.newParameter
        )
        fetch(
            '/api/parameters/',
            { headers, method: 'POST', body}
        ).then(
            res => res.json()
        ).then(
            parameter => this.setState({
                parameterList: [parameter, ...this.state.parameterList]
            })
        )   
    }

    @autobind
    changeNewParameterInput(event) {
        const {name, value} = event.target;
        this.setState({
            newParameter: {
                ...this.state.newParameter,
                [name]: value
            }
        })
    }

    @autobind
    deleteParameter(event, parameter) {
        event.preventDefault()
        const headers = {
            'Authorization': `Token ${this.props.auth.token}`,
            'Content-Type': 'application/json'
        };
        fetch(
            `/api/parameters/${parameter.id}/`,
            { headers, method: 'DELETE'}
        ).then(
            () => this.setState({
                parameterList: this.state.parameterList.filter(o => parameter.id !== o.id)
            })
        )   
    }

    render() {
        if (this.state.isLoading)
            return <Loading />;
        const id = this.props.match.params.id;
        const customer = this.state.customer;
        const zoneList = this.state.zoneList;
        const parameterList = this.state.parameterList
        return (
            <DetailContainer id={id}>
                <h1>{customer.name}</h1>
                <h2></h2>
                <form className="form-inline" onSubmit={this.addNewParameter}>
                    <select required className="form-control" name="zone_id" value={this.state.newParameter.zone} onChange={this.changeNewParameterInput}>
                        <option>Bereich auswählen</option>
                        {
                            zoneList.map(
                                zone => <option value={zone.id} key={`zone_${zone.id}`}>{zone.name}</option>
                            )
                        }
                    </select>
                    <input required className="form-control" type="text" placeholder="Name" name="name"  value={this.state.newParameter.name} onChange={this.changeNewParameterInput}/>
                    <input required className="form-control" type="text" placeholder="m2" name="m2" value={this.state.newParameter.m2} onChange={this.changeNewParameterInput} />
                    <input required className="form-control" type="textarea" placeholder="Kommentar" name="kommentar" value={this.state.newParameter.kommentar} onChange={this.changeNewParameterInput}/>
                    <button type="submit" className="btn btn-primary">Hinzufügen</button>
                </form>
                <br/>
                {
                    parameterList.map(
                        parameter => <p key={`parameter_${parameter.id}`}>{parameter.zone.name} {parameter.name} {parameter.m2} {parameter.kommentar} <a href="#" onClick={e=>this.deleteParameter(e, parameter)}>Löschen</a></p>
                    )
                }
            </DetailContainer>
        )
    }
}

